import { io } from "socket.io-client";
import {
  addMessage,
  editMessage,
  deleteMessage,
  setTyping,
  clearTyping,
  addReply,
  updateReactions
} from "shared/store/chatSlice";
import {
  updatePresence,
  setOnlineUsers
} from "shared/store/chatUserSlice";
import { getCookie } from "shared/utils/cookies";

let socket;

export const connectSocket = (userId, dispatch, selectedRoomId, currentUserId) => {
  if (!userId || socket?.connected) return;
  socket = io(process.env.REACT_APP_SOCKET_URL, {
    query: { userId  },
    auth: {
      accountId: getCookie("accountId"),
      token: getCookie("accessToken")
    },
    transports: ["websocket", "polling"], // ensure fallback support
    withCredentials: true
  });

  socket.on("connect", () => {
    console.log("✅ Connected to socket server");
  });

  socket.on("newMessage", (msg) => {
    dispatch(addMessage(msg));
  });

  socket.on("messageEdited", (payload) => {
    dispatch(editMessage(payload));

  });

  socket.on("messageDeleted", (payload) => {
    dispatch(deleteMessage(payload));
  });

  socket.on("replyMessage", (msg) => {
    console.log('messageReaction', msg);
    dispatch(addReply(msg));
  });

  socket.on("messageReaction", ({ messageId, reactions }) => {
    dispatch(updateReactions({ messageId, reactions }));
  });

  socket.on("typing", ({ roomId, userId, isTyping, profile }) => {
    if (userId !== currentUserId) {
      if (isTyping) {
        dispatch(setTyping({ userId, isTyping, profile }));
      } else {
        dispatch(clearTyping({ userId }));
      }
    }
  });


  socket.on("userOnline", ({ userId }) => {
    dispatch(updatePresence({ userId, status: "online" }));
  });

  socket.on("userOffline", ({ userId }) => {
    dispatch(updatePresence({ userId, status: "offline" }));
  });

  socket.on("presenceUpdate", ({ userId, status }) => {
    dispatch(updatePresence({ userId, status }));
  });

  socket.emit("getOnlineUsers", null, (users) => {
    dispatch(setOnlineUsers(users.map((id) => ({ userId: id, status: "online" }))));
  });
};

export const onSendMessage = (payload) => {
  if (socket?.connected) socket.emit("sendMessage", payload);
};

export const onReplyMessage = (payload) => {
  if (socket?.connected) socket.emit("replyMessage", payload);
};

export const onUpdateMessage = (payload) => {
  if (socket?.connected) socket.emit("editMessage", payload);
};

export const onRemoveMessage = (payload) => {
  if (socket?.connected) socket.emit("deleteMessage", payload);
};

export const onAddReaction = (payload) => {
  if (socket?.connected) socket.emit("addReaction", payload);
};

export const setTypingStatus = ({roomId, userId, isTyping}) => {
  if (socket?.connected) socket.emit("setTyping", { roomId, userId, isTyping });
};
